import React from 'react';
import { Gavel, Phone } from 'lucide-react';

/**
 * RBCONotice — Permanent, non-dismissible statutory notice about
 * Retirement Benefits Court Orders.
 *
 * Visible at the top of the Withdrawals & Loans tab. No close button,
 * no dismiss state. References 5 U.S.C. § 8435(c) and 5 C.F.R. Part 1653.
 */
export const RBCONotice = () => {
  return (
    <div
      className="panel p-4 border-l-4 border-l-[#B91C1C] bg-red-50 border-red-200"
      data-testid="rbco-notice"
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center shrink-0 mt-0.5">
          <Gavel size={14} className="text-[#B91C1C]" />
        </div>
        <div className="flex-1 text-xs text-red-900 leading-relaxed space-y-2">
          <p>
            <span className="font-bold tracking-wider uppercase text-[10px] text-[#B91C1C]">
              Important —
            </span>{' '}
            The UniFed Core does <b>not</b> process Qualified Domestic Relations Orders (QDROs).
            The UniFed Core only recognizes <b>Retirement Benefits Court Orders (RBCOs)</b> that
            meet specific UniFed Core statutory requirements{' '}
            <span className="font-mono text-[11px] text-red-800">
              (5 U.S.C. § 8435(c); 5 C.F.R. Part 1653)
            </span>.
          </p>
          <p>
            Receipt of an RBCO will <b>freeze your retirement account immediately</b> upon
            processing.
          </p>
          <p>
            If you have received or anticipate receiving a court order affecting your
            UniFed Core account, contact the{' '}
            <a
              href="tel:+18779683778"
              className="inline-flex items-center gap-1 font-bold text-[#B91C1C] underline underline-offset-2 hover:text-red-700"
              data-testid="rbco-thriftline-link"
            >
              <Phone size={11} /> UniFed Core ThriftLine at 1-877-968-3778
            </a>{' '}
            before submitting any withdrawals or transfers.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RBCONotice;
